import { Navigate } from "react-router-dom";
import { type ReactNode } from "react";
import { UserRole } from "@gryzonie/shared";
import { useAuthStore } from "./auth.store";

export function AdminRoute({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user || user.role !== UserRole.Admin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
